import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../../api/endpoints/users';

interface UserSelectProps {
  value?: number | null;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
  allowClear?: boolean;
}

/** Autocomplete simple de usuarios activos. Para listas chicas (5-20). */
export function UserSelect({
  value,
  onChange,
  placeholder = 'Selecciona usuario…',
  allowClear = true,
}: UserSelectProps): JSX.Element {
  const { data, isLoading } = useQuery({
    queryKey: ['users', 'active'],
    queryFn: () => usersApi.listActive(),
    staleTime: 60_000,
  });

  const options =
    data?.map((u) => ({
      label: `${u.firstName} ${u.lastName}`,
      value: u.id,
    })) ?? [];

  return (
    <Select
      showSearch
      allowClear={allowClear}
      loading={isLoading}
      placeholder={placeholder}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? undefined)}
      options={options}
      filterOption={(input, option) =>
        (option?.label as string).toLowerCase().includes(input.toLowerCase())
      }
      style={{ width: '100%' }}
    />
  );
}
